const translations = {
  "pt-BR": {
    // App
    app_name: "SOP & RAFT", app_subtitle: "Cozinha Inteligente",
    app_full: "Sistema Operacional de Precificação & Receitas Adaptadas em Fichas Técnicas",

    // Auth
    login: "Entrar", register: "Cadastrar", email: "Email", password: "Senha", name: "Nome",
    create_account: "Criar Conta", your_access_data: "Seus dados de acesso",
    already_have_account: "Já tem uma conta?", login_link: "Faça login",
    no_account: "Não tem conta?", register_link: "Cadastre-se",
    min_6_chars: "Mínimo 6 caracteres", next: "Próximo", previous: "Anterior", back: "Voltar",
    welcome_back: "Bem-vindo de volta", enter_credentials: "Entre com suas credenciais",
    your_password: "Sua senha", name_placeholder: "Seu nome", email_placeholder: "seu@email.com",

    // Onboarding
    business_profile: "Perfil do Negócio", how_identify: "Como você se identifica?",
    autonomo: "Autônomo", autonomo_desc: "Produtor caseiro, MEI, confeitaria individual. Interface simplificada — ative módulos avançados quando precisar.",
    empresa: "Empresa", empresa_desc: "Restaurante, buffet, padaria, franquia. Todos os módulos disponíveis com controle financeiro e operacional completo.",
    business_name: "Nome do Negócio", business_name_placeholder: "Ex: Doces da Ana",
    optional: "opcional", advanced_modules: "Módulos Avançados",
    all_preselected: "Todos os módulos estão pré-selecionados. Desmarque o que não precisar agora.",
    select_extras: "Selecione módulos extras se desejar. Você pode ativar depois na Central de Módulos.",
    creating: "Criando...",

    // Language
    language: "Idioma", select_language: "Escolha o idioma do aplicativo",

    // Sidebar
    section_operation: "Operacao", section_financial: "Financeiro", section_stock: "Estoque e Logistica", section_planning: "Planejamento", section_admin: "Administracao",
    nav_dashboard: "Menu Principal", nav_ingredients: "Ingredientes", nav_stock: "Estoque",
    nav_tech_sheets: "Fichas Técnicas", nav_production_orders: "Ordens de Produção",
    nav_measures: "Medidas", nav_pricing: "Precificação", nav_analytics: "Análises",
    nav_dre: "DRE & CMV", nav_waste: "Desperdício", nav_events: "Eventos",
    nav_shopping: "Lista de Compras", nav_suppliers: "Fornecedores",
    nav_attack_plan: "Plano de Ataque", nav_menu_eng: "Eng. Cardápio", nav_menu_builder: "Cardápios & Menus",
    nav_team: "Equipe", nav_reports: "Relatórios", nav_checklists: "Checklists", nav_pracas: "Praças", nav_memory: "Memoria IA", nav_module_center: "Central de Módulos",

    // Common
    save: "Salvar", cancel: "Cancelar", delete: "Deletar", edit: "Editar", create: "Criar",
    add: "Adicionar", search: "Buscar", confirm: "Confirmar", close: "Fechar",
    export_pdf: "PDF", share_whatsapp: "WhatsApp", loading: "Carregando...",
    no_data: "Nenhum dado encontrado.", success: "Sucesso!", error: "Erro",
    logout: "Sair", change_password: "Senha", help: "Ajuda", actions: "Ações",
    quantity: "Quantidade", unit: "Unidade", cost: "Custo", price: "Preço",
    total: "Total", date: "Data", status: "Status", notes: "Observações",
    category: "Categoria", description: "Descrição", view: "Ver", copy: "Copiar",
    produce: "Produzir", generate: "Gerar", apply: "Aplicar", update: "Atualizar",
    new_item: "Novo", all: "Todos", none: "Nenhum", yes: "Sim", no: "Não",
    required: "Obrigatório", items: "itens", of: "de",
    confirm_delete: "Tem certeza que deseja deletar?",

    // Dashboard
    dash_overview: "Visão geral do seu negócio", dash_estimated_profit: "Lucro Estimado",
    dash_total_cost: "Custo Total", dash_products: "Produtos", dash_ingredients_count: "Ingredientes",
    dash_stock_alerts: "Alertas de Estoque", dash_all_good: "Tudo em ordem!",
    dash_no_shortage: "Nenhum ingrediente em falta", dash_quick_access: "Acesso Rápido",
    dash_new_sheet: "Nova Ficha Técnica", dash_register_purchase: "Registrar Compra",
    dash_shopping_list: "Lista de Compras", dash_events: "Eventos",
    dash_create_recipe: "Criar uma nova receita", dash_stock_entry: "Entrada de estoque",
    dash_gen_shopping: "Gerar lista de compras", dash_manage_events: "Gerenciar eventos",
    dash_low_stock: "com estoque baixo", dash_out_of_stock: "sem estoque",

    // Ingredients
    ing_title: "Ingredientes", ing_subtitle: "Gerencie seus insumos e matérias-primas",
    ing_new: "Novo Ingrediente", ing_edit: "Editar Ingrediente",
    ing_name: "Nome do Ingrediente", ing_package_qty: "Quantidade do Pacote",
    ing_purchase_price: "Preço de Compra", ing_cost_per_unit: "Custo por Unidade",
    ing_eq_weight: "Peso Equivalente (g)", ing_no_ingredients: "Nenhum ingrediente cadastrado.",
    ing_search: "Buscar ingrediente...", ing_fc: "FC Padrão",

    // Stock
    stock_title: "Estoque", stock_subtitle: "Controle de entrada e saída de ingredientes",
    stock_entry: "Entrada", stock_exit: "Saída", stock_scan: "Escanear Nota",
    stock_current: "Estoque Atual", stock_minimum: "Mínimo", stock_set_minimum: "Definir Estoque Mínimo",
    stock_history: "Histórico de Movimentações", stock_no_movements: "Sem movimentações",
    stock_low_alert: "Estoque baixo!", stock_entry_note: "Observação da entrada",
    stock_exit_note: "Observação da saída",

    // Tech Sheets
    ts_title: "Fichas Técnicas", ts_subtitle: "Receitas completas com custos calculados",
    ts_new: "Nova Ficha", ts_edit: "Editar Ficha", ts_yield: "Rendimento",
    ts_total_cost: "Custo Total", ts_cost_per_unit: "Custo/Unidade",
    ts_ingredients: "Ingredientes", ts_add_ingredient: "Adicionar Ingrediente",
    ts_add_sub_recipe: "Sub-receita", ts_prep_mode: "Modo de Preparo",
    ts_photo: "Foto", ts_baker_pct: "Fórmula do Padeiro", ts_qb: "QB",
    ts_gross_weight: "Peso Bruto", ts_net_weight: "Peso Líquido", ts_fc: "FC",
    ts_item_cost: "Custo Item", ts_search: "Buscar ficha técnica...",
    ts_no_sheets: "Nenhuma ficha técnica cadastrada.",
    ts_portion_weight: "Gramatura/Porção (kg)", ts_select_ingredient: "Selecione o ingrediente",
    ts_select_sheet: "Selecione a ficha...",

    // Pricing
    pr_title: "Precificação", pr_subtitle: "Calcule o preço de venda dos seus produtos",
    pr_method: "Método", pr_markup: "Markup", pr_margin: "Margem de Lucro",
    pr_selling_price: "Preço de Venda", pr_profit: "Lucro", pr_per_unit: "por unidade",
    pr_overhead: "Custo Operacional", pr_understand: "Entender Cálculo",
    pr_no_pricing: "Nenhuma precificação cadastrada.",

    // Analytics
    an_title: "Análises", an_subtitle: "Indicadores financeiros dos seus produtos",
    an_most_profitable: "Mais Lucrativos", an_risk: "Produtos em Risco",
    an_cost_vs_price: "Custo vs Preço",

    // Events
    ev_title: "Eventos", ev_subtitle: "Gerencie seus eventos e encomendas",
    ev_new: "Novo Evento", ev_edit: "Editar Evento",
    ev_name: "Nome do Evento", ev_date: "Data do Evento",
    ev_sheets: "Fichas do Evento", ev_estimated_cost: "Custo Estimado",
    ev_shopping_list: "Gerar Lista de Compras", ev_pricing: "Precificar",
    ev_no_events: "Nenhum evento cadastrado.",

    // Shopping List
    sl_title: "Lista de Compras", sl_subtitle: "Gere listas de compras e consulte o histórico",
    sl_new_list: "Nova Lista", sl_saved_lists: "Listas Salvas",
    sl_tech_sheets: "Fichas Técnicas", sl_extra_ingredients: "Ingredientes Avulsos",
    sl_generate: "Gerar Lista", sl_deduct_stock: "Descontar Estoque",
    sl_confirm_purchase: "Confirmar Compra", sl_purchase_confirmed: "Compra Confirmada",
    sl_save_list: "Salvar Lista", sl_list_name: "Nome da lista (opcional)",
    sl_no_saved: "Nenhuma lista salva.", sl_items_count: "Ingredientes",
    sl_packages: "Pacotes Total", sl_total_cost: "Custo Total",
    sl_pending: "Pendente", sl_confirmed: "Confirmada", sl_stock_deducted: "Estoque descontado",
    sl_search_sheet: "Buscar ficha técnica...", sl_search_extra: "Buscar ingrediente avulso...",
    sl_generated: "Lista de Compras Gerada", sl_package_size: "Tam. Pacote",
    sl_packages_needed: "Pacotes", sl_price_per_package: "Preço/Pacote",

    // Measures
    mc_title: "Conversão de Medidas", mc_subtitle: "Tabela de referência para conversões culinárias",
    mc_ingredient: "Ingrediente", mc_teaspoon: "Colher de Chá", mc_tablespoon: "Colher de Sopa",
    mc_cup: "Xícara",

    // Attack Plan
    ap_title: "Plano de Ataque", ap_subtitle: "Organize a produção da cozinha",
    ap_generate_ai: "Gerar com IA", ap_create_manual: "Criar Manualmente",
    ap_select_sheets: "Selecione as fichas para o plano",
    ap_phase: "Fase", ap_task: "Tarefa", ap_done: "Concluída",
    ap_no_plans: "Nenhum plano de ataque criado.",

    // DRE
    dre_title: "DRE & CMV", dre_subtitle: "Demonstrativo de Resultado e Custo de Mercadoria Vendida",
    dre_monthly: "DRE Mensal", dre_cmv_history: "CMV Histórico", dre_sales: "Vendas",
    dre_register_sale: "Registrar Venda", dre_revenue: "Receita Bruta",
    dre_cmv: "CMV", dre_op_costs: "Custos Operacionais", dre_gross_profit: "Lucro Bruto",
    dre_net_profit: "Lucro Líquido", dre_net_margin: "Margem",
    dre_cmv_target: "Meta CMV: 28% a 35%", dre_within_target: "Dentro da meta!",
    dre_above_target: "Acima da meta — revise custos ou preços.",
    dre_select_product: "Selecione o produto vendido...", dre_amount_received: "Valor Recebido (R$)",
    dre_no_sales: "Nenhuma venda registrada ainda.", dre_simplified: "DRE Simplificado",

    // Suppliers
    sup_title: "Fornecedores", sup_subtitle: "Gestão de fornecedores e contatos",
    sup_new: "Novo Fornecedor", sup_edit: "Editar Fornecedor",
    sup_contact: "Contato", sup_phone: "Telefone", sup_categories: "Categorias",
    sup_address: "Endereço", sup_no_suppliers: "Nenhum fornecedor cadastrado.",
    sup_search: "Buscar fornecedor...",

    // Production Orders
    po_title: "Ordens de Produção", po_subtitle: "Planeje e controle a produção da cozinha",
    po_new: "Nova Ordem", po_name: "Nome da Ordem", po_scheduled: "Data Programada",
    po_start: "Iniciar", po_complete: "Concluir", po_cancel_order: "Cancelar",
    po_pending: "Pendente", po_in_production: "Em Produção", po_completed: "Concluída",
    po_cancelled: "Cancelada", po_no_orders: "Nenhuma ordem de produção.",
    po_confirm_complete: "Concluir esta ordem? O estoque será descontado automaticamente.",

    // Waste
    ws_title: "Controle de Desperdício", ws_subtitle: "Registre e analise perdas da operação",
    ws_new: "Registrar Perda", ws_reason: "Motivo", ws_estimated_cost: "Custo Est.",
    ws_expired: "Vencido", ws_damage: "Quebra/Dano", ws_leftover: "Sobra de Produção",
    ws_prep_loss: "Perda no Preparo", ws_other: "Outro",
    ws_monthly_records: "Registros (Mês)", ws_total_loss: "Custo Total Perdas",
    ws_no_records: "Nenhum registro de desperdício.",

    // Team
    tm_title: "Equipe e Permissões", tm_subtitle: "Gerencie membros, cargos e módulos de acesso",
    tm_invite: "Convidar Membro", tm_role: "Papel", tm_audit: "Auditoria",
    tm_admin: "Administrador", tm_editor: "Editor", tm_viewer: "Visualizador",
    tm_initial_password: "Senha inicial", tm_change_first_login: "O membro deve alterar a senha no primeiro acesso.",
    tm_no_audit: "Nenhuma atividade registrada.", tm_datetime: "Data/Hora",
    tm_user: "Usuário", tm_action: "Ação", tm_details: "Detalhes",
    tm_employee: "Funcionário", tm_owner: "Proprietário",
    tm_employee_badge: "Funcionário", tm_owner_badge: "Proprietário",
    tm_readonly_notice: "Você tem acesso somente para visualização.",
    tm_team_tab: "Equipe", tm_remove_confirm: "Remover {name} da equipe?",
    tm_name_required: "Nome e email obrigatórios",
    tm_invited_success: "Membro convidado!",
    tm_role_updated: "Papel atualizado!", tm_member_removed: "Membro removido",
    tm_viewer_write_blocked: "Permissão insuficiente — somente visualização",
    tm_positions_tab: "Cargos", tm_position: "Cargo", tm_no_position: "Sem cargo",
    tm_new_position: "Novo Cargo", tm_position_name: "Nome do Cargo",
    tm_permission_level: "Nível de Permissão",
    tm_position_created: "Cargo criado!", tm_position_updated: "Cargo atualizado!",
    tm_position_deleted: "Cargo removido!",
    tm_edit_member: "Editar Funcionário", tm_modules: "Módulos",
    tm_select_modules: "Selecione os módulos que este funcionário pode acessar",
    tm_all_modules: "Todos os módulos da empresa",
    tm_member_updated: "Funcionário atualizado!",
    tm_no_positions: "Nenhum cargo criado. Crie cargos para organizar sua equipe.",
    tm_delete_position_confirm: "Excluir o cargo '{name}'?",
    tm_save: "Salvar",

    // Menu Engineering
    me_title: "Engenharia de Cardápio", me_subtitle: "Análise de popularidade × lucratividade dos seus produtos",
    me_star: "Estrela", me_workhorse: "Burro de Carga", me_puzzle: "Quebra-cabeça", me_dog: "Cachorro",
    me_star_desc: "Alta popularidade + Alta lucratividade",
    me_workhorse_desc: "Alta popularidade + Baixa lucratividade",
    me_puzzle_desc: "Baixa popularidade + Alta lucratividade",
    me_dog_desc: "Baixa popularidade + Baixa lucratividade",
    me_no_data: "Registre vendas para ver a análise do cardápio.",
    me_sold: "vendido(s)", me_total_profit: "lucro total",

    // BI Dashboard
    bi_title: "Relatórios & BI", bi_subtitle: "Visão consolidada do negócio",
    bi_revenue: "Receita", bi_cmv: "CMV", bi_waste: "Desperdício",
    bi_net_profit: "Lucro Líquido", bi_margin: "Margem",
    bi_alerts: "Alertas Inteligentes", bi_trend: "Tendência Mensal (6 meses)",
    bi_low_stock: "ingrediente(s) com estoque baixo",
    bi_expiring: "lote(s) vencendo em 7 dias",
    bi_price_up: "preço subiu", bi_price_down: "preço caiu",
    bi_sales_month: "Vendas no Mês", bi_ops_completed: "OPs Concluídas",
    bi_avg_ticket: "Ticket Médio", bi_vs_prev: "vs mês anterior",
    bi_target: "Meta: 28-35%", bi_no_data: "Sem dados",

    // Module Center
    mod_title: "Central de Módulos", mod_subtitle: "Ative ou desative funcionalidades do seu painel.",
    mod_profile: "Perfil", mod_core: "Core Operacional — Sempre Ativo",
    mod_advanced: "Módulos Avançados de Escala",
    mod_deactivate_info: "Desativar um módulo remove as telas do menu, mas preserva todos os seus dados.",

    // Sous-Chef
    souschef_title: "Sous-Chef AI", souschef_subtitle: "Copiloto Gastronômico",
    souschef_greeting: "Olá! Sou o Sous-Chef AI",
    souschef_desc: "Posso criar receitas, ajudar com precificação, explicar funcionalidades do app e muito mais.",
    souschef_placeholder: "Pergunte ao Sous-Chef...",
    souschef_recipe_detected: "Receita Detectada", souschef_apply: "Aplicar à Ficha Técnica",

    // Global search
    search_placeholder: "Buscar ingredientes, fichas, fornecedores...",
    search_no_results: "Nenhum resultado encontrado",

    // Password dialog
    pwd_change: "Alterar Senha", pwd_current: "Senha Atual", pwd_new: "Nova Senha",
    pwd_confirm: "Confirmar Nova Senha", pwd_current_placeholder: "Digite sua senha atual",
    pwd_new_placeholder: "Mínimo 6 caracteres", pwd_confirm_placeholder: "Repita a nova senha",
    pwd_mismatch: "As senhas não coincidem", pwd_too_short: "A nova senha deve ter pelo menos 6 caracteres",
    pwd_changed: "Senha alterada com sucesso!",
    // Fichas Técnicas — Etapa 5 i18n
    ts_manage_subtitle: "Crie e gerencie receitas dos seus produtos",
    ts_export_excel: "Exportar Excel", ts_measures: "Medidas", ts_import_ai: "Importar com IA",
    ts_new_sheet: "Nova Ficha Técnica", ts_edit_sheet: "Editar Ficha Técnica",
    ts_edit_ingredient: "Editar Ingrediente", ts_save_changes: "Salvar alterações", ts_cancel: "Cancelar",
    ts_search_sheet: "Buscar ficha...", ts_sort_edited: "Editadas recentemente", ts_sort_opened: "Abertas recentemente",
    ts_sort_created: "Criadas recentemente", ts_sort_az: "Ordem alfabética (A-Z)", ts_sort_za: "Ordem alfabética (Z-A)",
    ts_all_types: "Todos os tipos", ts_normal_sheets: "Fichas normais", ts_subrecipes: "Sub-receitas",
    ts_registered: "Fichas Técnicas Cadastradas", ts_personal: "Fichas Técnicas Pessoais",
    ts_loading: "Carregando...", sl_confirm_purchase: "Confirmar Compra",

    // Etapa 10: Estoque
    st_title: "Estoque", st_subtitle: "Controle de entradas, saídas e estoque mínimo",
    st_scan_receipt: "Escanear Nota", st_entry: "Entrada", st_exit: "Saída",
    st_items: "Itens em Estoque", st_total_value: "Valor Total", st_low: "Estoque Baixo", st_zero: "Zerados",
    st_alerts_title: "Alertas de Estoque", st_min_short: "mín", st_current_tab: "Estoque Atual", st_history_tab: "Histórico",
    st_no_items: "Nenhum item no estoque", st_no_items_hint: "Cadastre ingredientes e registre entradas",
    st_ingredient: "Ingrediente", st_minimum: "Mínimo", st_value: "Valor",
    st_no_movements: "Nenhuma movimentação", st_no_movements_hint: "O histórico aparecerá aqui",
    st_type: "Tipo", st_note_opt: "Observação (opcional)",
    st_register_entry: "Registrar Entrada", st_register_exit: "Registrar Saída",
    st_select_placeholder: "Selecione...", st_confirm_entry: "Confirmar Entrada", st_confirm_exit: "Confirmar Saída",
    st_define_min: "Definir Estoque Mínimo", st_min_qty: "Quantidade mínima",
    st_min_hint: "Um alerta será exibido quando o estoque ficar abaixo desse valor",
    st_entry_success: "Entrada registrada com sucesso!", st_exit_success: "Saída registrada com sucesso!",
    st_entry_error: "Erro ao registrar entrada", st_exit_error: "Erro ao registrar saída",
    st_select_required: "Selecione um ingrediente e informe a quantidade",
    st_min_updated: "Estoque mínimo atualizado!", st_min_error: "Erro ao atualizar estoque mínimo",
    st_load_error: "Erro ao carregar estoque", st_ok: "OK", st_low_badge: "Baixo", st_zero_badge: "Zerado",
    st_set_min_title: "Definir mínimo", st_min_btn: "Mín",

    // Etapa 10: Eventos (restante)
    ev_edit_event: "Editar Evento", ev_new_event: "Novo Evento", ev_date_opt: "Data (opcional)", ev_desc_opt: "Descrição (opcional)",
    ev_name_label: "Nome do Evento", ev_name_placeholder: "Ex: Casamento 200 convidados", ev_desc_placeholder: "Detalhes do evento...",
    ev_no_sheets: "Nenhuma ficha técnica cadastrada.", ev_create_first: "Crie seu primeiro evento!",
    ev_search: "Buscar evento...", ev_view: "Ver", ev_shopping: "Compras", ev_produce: "Produzir",
    ev_delete: "Deletar", ev_update: "Atualizar", ev_save: "Salvar Evento",
    ev_sheets_label: "Fichas", ev_sheets_count: "ficha(s)",
    ev_product: "Produto", ev_qty: "Qtd", ev_unit_cost: "Custo Unit.", ev_subtotal: "Subtotal",
    ev_gen_shopping: "Gerar Lista de Compras", ev_cost: "Custo",
    ev_load_error: "Erro ao carregar dados", ev_need_sheet: "Adicione pelo menos uma ficha técnica ao evento",
    ev_updated: "Evento atualizado com sucesso!", ev_created: "Evento criado com sucesso!",
    ev_save_error: "Erro ao salvar evento", ev_delete_confirm: "Tem certeza que deseja deletar este evento?",
    ev_deleted: "Evento deletado com sucesso!", ev_delete_error: "Erro ao deletar evento",
    ev_produce_confirm: "Deseja registrar a produção do evento \"{name}\"?\nIsso irá descontar todos os ingredientes do estoque.",
    ev_produce_error: "Erro ao registrar produção do evento", ev_insufficient: "Estoque insuficiente",
    ev_pdf_done: "PDF do evento gerado!", ev_whatsapp_opening: "Abrindo WhatsApp...",

    // Etapa 10: Equipe (restante)
    tm_invite_link: "Convidar por link", tm_invite_link_desc: "Gere um link e envie para a pessoa. Ela cria a própria senha (ou entra com a conta que já tem) e já cai na sua equipe. Válido por 7 dias.",
    tm_access_level: "Nível de acesso",
    tm_role_editor_desc: "Editor — pode criar e editar", tm_role_viewer_desc: "Visualizador — somente leitura", tm_role_admin_desc: "Administrador — acesso total",
    tm_generate_link: "Gerar link", tm_generating: "Gerando...", tm_link_label: "Link de convite",
    tm_link_copied: "Link copiado!", tm_copy_manual: "Selecione o link e copie manualmente (Ctrl+C)",
    tm_link_note: "Se a pessoa já tiver conta, os dados dela viram itens pessoais ao entrar.",
    tm_email_hint: "Se o e-mail já tiver conta no SOP & RAFT, ela será vinculada à sua equipe e os dados dela viram itens pessoais.",
    tm_role_hint: "Se um cargo for selecionado abaixo, o nível do cargo prevalece.",
    tm_position_example: "Ex: Chef de Cozinha", tm_link_error: "Erro ao gerar link",

    // Etapa 10: Paginação
    pg_showing: "Mostrando", pg_page: "Página",
  },

  en: {
    app_name: "SOP & RAFT", app_subtitle: "Smart Kitchen",
    app_full: "Pricing Operating System & Recipes Adapted in Technical Sheets",

    login: "Log in", register: "Sign up", email: "Email", password: "Password", name: "Name",
    create_account: "Create Account", your_access_data: "Your access details",
    already_have_account: "Already have an account?", login_link: "Log in",
    no_account: "Don't have an account?", register_link: "Sign up",
    min_6_chars: "Minimum 6 characters", next: "Next", previous: "Previous", back: "Back",
    welcome_back: "Welcome back", enter_credentials: "Enter your credentials",
    your_password: "Your password", name_placeholder: "Your name", email_placeholder: "your@email.com",

    business_profile: "Business Profile", how_identify: "How do you identify?",
    autonomo: "Independent", autonomo_desc: "Home producer, sole proprietor. Simplified interface — activate advanced modules when needed.",
    empresa: "Business", empresa_desc: "Restaurant, buffet, bakery, franchise. All modules available with full control.",
    business_name: "Business Name", business_name_placeholder: "E.g.: Ana's Bakery",
    optional: "optional", advanced_modules: "Advanced Modules",
    all_preselected: "All modules are pre-selected. Uncheck what you don't need now.",
    select_extras: "Select extra modules if desired. You can activate them later in the Module Center.",
    creating: "Creating...",

    language: "Language", select_language: "Choose the app language",

    section_operation: "Operations", section_financial: "Financial", section_stock: "Stock & Logistics", section_planning: "Planning", section_admin: "Administration",
    nav_dashboard: "Main Menu", nav_ingredients: "Ingredients", nav_stock: "Stock",
    nav_tech_sheets: "Technical Sheets", nav_production_orders: "Production Orders",
    nav_measures: "Conversions", nav_pricing: "Pricing", nav_analytics: "Analytics",
    nav_dre: "P&L / COGS", nav_waste: "Waste", nav_events: "Events",
    nav_shopping: "Shopping List", nav_suppliers: "Suppliers",
    nav_attack_plan: "Attack Plan", nav_menu_eng: "Menu Engineering", nav_menu_builder: "Menus & Cards",
    nav_team: "Team", nav_reports: "Reports", nav_checklists: "Checklists", nav_pracas: "Stations", nav_memory: "AI Memory", nav_module_center: "Module Center",

    save: "Save", cancel: "Cancel", delete: "Delete", edit: "Edit", create: "Create",
    add: "Add", search: "Search", confirm: "Confirm", close: "Close",
    export_pdf: "PDF", share_whatsapp: "WhatsApp", loading: "Loading...",
    no_data: "No data found.", success: "Success!", error: "Error",
    logout: "Log out", change_password: "Password", help: "Help", actions: "Actions",
    quantity: "Quantity", unit: "Unit", cost: "Cost", price: "Price",
    total: "Total", date: "Date", status: "Status", notes: "Notes",
    category: "Category", description: "Description", view: "View", copy: "Copy",
    produce: "Produce", generate: "Generate", apply: "Apply", update: "Update",
    new_item: "New", all: "All", none: "None", yes: "Yes", no: "No",
    required: "Required", items: "items", of: "of",
    confirm_delete: "Are you sure you want to delete?",

    dash_overview: "Business overview", dash_estimated_profit: "Estimated Profit",
    dash_total_cost: "Total Cost", dash_products: "Products", dash_ingredients_count: "Ingredients",
    dash_stock_alerts: "Stock Alerts", dash_all_good: "All good!",
    dash_no_shortage: "No ingredients short", dash_quick_access: "Quick Access",
    dash_new_sheet: "New Technical Sheet", dash_register_purchase: "Register Purchase",
    dash_shopping_list: "Shopping List", dash_events: "Events",
    dash_create_recipe: "Create a new recipe", dash_stock_entry: "Stock entry",
    dash_gen_shopping: "Generate shopping list", dash_manage_events: "Manage events",
    dash_low_stock: "with low stock", dash_out_of_stock: "out of stock",

    ing_title: "Ingredients", ing_subtitle: "Manage your supplies and raw materials",
    ing_new: "New Ingredient", ing_edit: "Edit Ingredient",
    ing_name: "Ingredient Name", ing_package_qty: "Package Quantity",
    ing_purchase_price: "Purchase Price", ing_cost_per_unit: "Cost per Unit",
    ing_eq_weight: "Equivalent Weight (g)", ing_no_ingredients: "No ingredients registered.",
    ing_search: "Search ingredient...", ing_fc: "Default FC",

    stock_title: "Stock", stock_subtitle: "Ingredient entry and exit control",
    stock_entry: "Entry", stock_exit: "Exit", stock_scan: "Scan Receipt",
    stock_current: "Current Stock", stock_minimum: "Minimum", stock_set_minimum: "Set Minimum Stock",
    stock_history: "Movement History", stock_no_movements: "No movements",
    stock_low_alert: "Low stock!", stock_entry_note: "Entry note", stock_exit_note: "Exit note",

    ts_title: "Technical Sheets", ts_subtitle: "Complete recipes with calculated costs",
    ts_new: "New Sheet", ts_edit: "Edit Sheet", ts_yield: "Yield",
    ts_total_cost: "Total Cost", ts_cost_per_unit: "Cost/Unit",
    ts_ingredients: "Ingredients", ts_add_ingredient: "Add Ingredient",
    ts_add_sub_recipe: "Sub-recipe", ts_prep_mode: "Preparation Method",
    ts_photo: "Photo", ts_baker_pct: "Baker's Percentage", ts_qb: "QB",
    ts_gross_weight: "Gross Weight", ts_net_weight: "Net Weight", ts_fc: "CF",
    ts_item_cost: "Item Cost", ts_search: "Search technical sheet...",
    ts_no_sheets: "No technical sheets registered.",
    ts_portion_weight: "Portion Weight (kg)", ts_select_ingredient: "Select ingredient",
    ts_select_sheet: "Select sheet...",

    pr_title: "Pricing", pr_subtitle: "Calculate the selling price of your products",
    pr_method: "Method", pr_markup: "Markup", pr_margin: "Profit Margin",
    pr_selling_price: "Selling Price", pr_profit: "Profit", pr_per_unit: "per unit",
    pr_overhead: "Operational Cost", pr_understand: "Understand Calculation",
    pr_no_pricing: "No pricing registered.",

    an_title: "Analytics", an_subtitle: "Financial indicators for your products",
    an_most_profitable: "Most Profitable", an_risk: "Products at Risk",
    an_cost_vs_price: "Cost vs Price",

    ev_title: "Events", ev_subtitle: "Manage your events and orders",
    ev_new: "New Event", ev_edit: "Edit Event",
    ev_name: "Event Name", ev_date: "Event Date",
    ev_sheets: "Event Sheets", ev_estimated_cost: "Estimated Cost",
    ev_shopping_list: "Generate Shopping List", ev_pricing: "Price",
    ev_no_events: "No events registered.",

    sl_title: "Shopping List", sl_subtitle: "Generate shopping lists and check history",
    sl_new_list: "New List", sl_saved_lists: "Saved Lists",
    sl_tech_sheets: "Technical Sheets", sl_extra_ingredients: "Standalone Ingredients",
    sl_generate: "Generate List", sl_deduct_stock: "Deduct Stock",
    sl_confirm_purchase: "Confirm Purchase", sl_purchase_confirmed: "Purchase Confirmed",
    sl_save_list: "Save List", sl_list_name: "List name (optional)",
    sl_no_saved: "No saved lists.", sl_items_count: "Ingredients",
    sl_packages: "Total Packages", sl_total_cost: "Total Cost",
    sl_pending: "Pending", sl_confirmed: "Confirmed", sl_stock_deducted: "Stock deducted",
    sl_search_sheet: "Search technical sheet...", sl_search_extra: "Search standalone ingredient...",
    sl_generated: "Shopping List Generated", sl_package_size: "Package Size",
    sl_packages_needed: "Packages", sl_price_per_package: "Price/Package",

    mc_title: "Unit Conversions", mc_subtitle: "Reference table for culinary conversions",
    mc_ingredient: "Ingredient", mc_teaspoon: "Teaspoon", mc_tablespoon: "Tablespoon", mc_cup: "Cup",

    ap_title: "Attack Plan", ap_subtitle: "Organize kitchen production",
    ap_generate_ai: "Generate with AI", ap_create_manual: "Create Manually",
    ap_select_sheets: "Select sheets for the plan",
    ap_phase: "Phase", ap_task: "Task", ap_done: "Completed",
    ap_no_plans: "No attack plans created.",

    dre_title: "P&L / COGS", dre_subtitle: "Profit & Loss Statement and Cost of Goods Sold",
    dre_monthly: "Monthly P&L", dre_cmv_history: "COGS History", dre_sales: "Sales",
    dre_register_sale: "Register Sale", dre_revenue: "Gross Revenue",
    dre_cmv: "COGS", dre_op_costs: "Operational Costs", dre_gross_profit: "Gross Profit",
    dre_net_profit: "Net Profit", dre_net_margin: "Margin",
    dre_cmv_target: "COGS Target: 28% to 35%", dre_within_target: "Within target!",
    dre_above_target: "Above target — review costs or prices.",
    dre_select_product: "Select the product sold...", dre_amount_received: "Amount Received",
    dre_no_sales: "No sales registered yet.", dre_simplified: "Simplified P&L",

    sup_title: "Suppliers", sup_subtitle: "Supplier management and contacts",
    sup_new: "New Supplier", sup_edit: "Edit Supplier",
    sup_contact: "Contact", sup_phone: "Phone", sup_categories: "Categories",
    sup_address: "Address", sup_no_suppliers: "No suppliers registered.", sup_search: "Search supplier...",

    po_title: "Production Orders", po_subtitle: "Plan and control kitchen production",
    po_new: "New Order", po_name: "Order Name", po_scheduled: "Scheduled Date",
    po_start: "Start", po_complete: "Complete", po_cancel_order: "Cancel",
    po_pending: "Pending", po_in_production: "In Production", po_completed: "Completed",
    po_cancelled: "Cancelled", po_no_orders: "No production orders.",
    po_confirm_complete: "Complete this order? Stock will be deducted automatically.",

    ws_title: "Waste Control", ws_subtitle: "Record and analyze operational losses",
    ws_new: "Record Loss", ws_reason: "Reason", ws_estimated_cost: "Est. Cost",
    ws_expired: "Expired", ws_damage: "Damage/Breakage", ws_leftover: "Production Leftover",
    ws_prep_loss: "Prep Loss", ws_other: "Other",
    ws_monthly_records: "Records (Month)", ws_total_loss: "Total Loss Cost",
    ws_no_records: "No waste records.",

    tm_title: "Team & Permissions", tm_subtitle: "Manage members, positions, and module access",
    tm_invite: "Invite Member", tm_role: "Role", tm_audit: "Audit Log",
    tm_admin: "Administrator", tm_editor: "Editor", tm_viewer: "Viewer",
    tm_initial_password: "Initial password", tm_change_first_login: "Member should change password on first login.",
    tm_no_audit: "No activity recorded.", tm_datetime: "Date/Time",
    tm_user: "User", tm_action: "Action", tm_details: "Details",
    tm_employee: "Employee", tm_owner: "Owner",
    tm_employee_badge: "Employee", tm_owner_badge: "Owner",
    tm_readonly_notice: "You have view-only access.",
    tm_team_tab: "Team", tm_remove_confirm: "Remove {name} from team?",
    tm_name_required: "Name and email are required",
    tm_invited_success: "Member invited!",
    tm_role_updated: "Role updated!", tm_member_removed: "Member removed",
    tm_viewer_write_blocked: "Insufficient permission — view only",
    tm_positions_tab: "Positions", tm_position: "Position", tm_no_position: "No position",
    tm_new_position: "New Position", tm_position_name: "Position Name",
    tm_permission_level: "Permission Level",
    tm_position_created: "Position created!", tm_position_updated: "Position updated!",
    tm_position_deleted: "Position removed!",
    tm_edit_member: "Edit Employee", tm_modules: "Modules",
    tm_select_modules: "Select modules this employee can access",
    tm_all_modules: "All company modules",
    tm_member_updated: "Employee updated!",
    tm_no_positions: "No positions created. Create positions to organize your team.",
    tm_delete_position_confirm: "Delete position '{name}'?",
    tm_save: "Save",

    me_title: "Menu Engineering", me_subtitle: "Popularity × profitability analysis of your products",
    me_star: "Star", me_workhorse: "Workhorse", me_puzzle: "Puzzle", me_dog: "Dog",
    me_star_desc: "High popularity + High profitability",
    me_workhorse_desc: "High popularity + Low profitability",
    me_puzzle_desc: "Low popularity + High profitability",
    me_dog_desc: "Low popularity + Low profitability",
    me_no_data: "Register sales to see menu analysis.", me_sold: "sold", me_total_profit: "total profit",

    bi_title: "Reports & BI", bi_subtitle: "Consolidated business view",
    bi_revenue: "Revenue", bi_cmv: "COGS", bi_waste: "Waste",
    bi_net_profit: "Net Profit", bi_margin: "Margin",
    bi_alerts: "Smart Alerts", bi_trend: "Monthly Trend (6 months)",
    bi_low_stock: "ingredient(s) with low stock", bi_expiring: "lot(s) expiring in 7 days",
    bi_price_up: "price increased", bi_price_down: "price decreased",
    bi_sales_month: "Sales This Month", bi_ops_completed: "Completed POs",
    bi_avg_ticket: "Average Ticket", bi_vs_prev: "vs previous month",
    bi_target: "Target: 28-35%", bi_no_data: "No data",

    mod_title: "Module Center", mod_subtitle: "Activate or deactivate features in your panel.",
    mod_profile: "Profile", mod_core: "Core Operations — Always Active",
    mod_advanced: "Advanced Scale Modules",
    mod_deactivate_info: "Deactivating a module hides its screens but preserves all your data.",

    souschef_title: "Sous-Chef AI", souschef_subtitle: "Culinary Copilot",
    souschef_greeting: "Hello! I'm Sous-Chef AI",
    souschef_desc: "I can create recipes, help with pricing, explain app features and much more.",
    souschef_placeholder: "Ask Sous-Chef...",
    souschef_recipe_detected: "Recipe Detected", souschef_apply: "Apply to Technical Sheet",

    search_placeholder: "Search ingredients, sheets, suppliers...",
    search_no_results: "No results found",

    pwd_change: "Change Password", pwd_current: "Current Password", pwd_new: "New Password",
    pwd_confirm: "Confirm New Password", pwd_current_placeholder: "Enter your current password",
    pwd_new_placeholder: "Minimum 6 characters", pwd_confirm_placeholder: "Repeat new password",
    pwd_mismatch: "Passwords don't match", pwd_too_short: "New password must have at least 6 characters",
    pwd_changed: "Password changed successfully!",
    // Technical Sheets — Stage 5 i18n
    ts_manage_subtitle: "Create and manage your product recipes",
    ts_export_excel: "Export Excel", ts_measures: "Measures", ts_import_ai: "Import with AI",
    ts_new_sheet: "New Technical Sheet", ts_edit_sheet: "Edit Technical Sheet",
    ts_edit_ingredient: "Edit Ingredient", ts_save_changes: "Save changes", ts_cancel: "Cancel",
    ts_search_sheet: "Search sheet...", ts_sort_edited: "Recently edited", ts_sort_opened: "Recently opened",
    ts_sort_created: "Recently created", ts_sort_az: "Alphabetical (A-Z)", ts_sort_za: "Alphabetical (Z-A)",
    ts_all_types: "All types", ts_normal_sheets: "Regular sheets", ts_subrecipes: "Sub-recipes",
    ts_registered: "Registered Technical Sheets", ts_personal: "Personal Technical Sheets",
    ts_loading: "Loading...", sl_confirm_purchase: "Confirm Purchase",

    // Etapa 10: Stock
    st_title: "Stock", st_subtitle: "Control entries, exits and minimum stock",
    st_scan_receipt: "Scan Receipt", st_entry: "Entry", st_exit: "Exit",
    st_items: "Items in Stock", st_total_value: "Total Value", st_low: "Low Stock", st_zero: "Out of Stock",
    st_alerts_title: "Stock Alerts", st_min_short: "min", st_current_tab: "Current Stock", st_history_tab: "History",
    st_no_items: "No items in stock", st_no_items_hint: "Register ingredients and record entries",
    st_ingredient: "Ingredient", st_minimum: "Minimum", st_value: "Value",
    st_no_movements: "No movements", st_no_movements_hint: "History will appear here",
    st_type: "Type", st_note_opt: "Note (optional)",
    st_register_entry: "Record Entry", st_register_exit: "Record Exit",
    st_select_placeholder: "Select...", st_confirm_entry: "Confirm Entry", st_confirm_exit: "Confirm Exit",
    st_define_min: "Set Minimum Stock", st_min_qty: "Minimum quantity",
    st_min_hint: "An alert will be shown when stock falls below this value",
    st_entry_success: "Entry recorded successfully!", st_exit_success: "Exit recorded successfully!",
    st_entry_error: "Error recording entry", st_exit_error: "Error recording exit",
    st_select_required: "Select an ingredient and enter the quantity",
    st_min_updated: "Minimum stock updated!", st_min_error: "Error updating minimum stock",
    st_load_error: "Error loading stock", st_ok: "OK", st_low_badge: "Low", st_zero_badge: "Empty",
    st_set_min_title: "Set minimum", st_min_btn: "Min",

    // Etapa 10: Events (remaining)
    ev_edit_event: "Edit Event", ev_new_event: "New Event", ev_date_opt: "Date (optional)", ev_desc_opt: "Description (optional)",
    ev_name_label: "Event Name", ev_name_placeholder: "E.g.: Wedding 200 guests", ev_desc_placeholder: "Event details...",
    ev_no_sheets: "No technical sheets registered.", ev_create_first: "Create your first event!",
    ev_search: "Search event...", ev_view: "View", ev_shopping: "Shopping", ev_produce: "Produce",
    ev_delete: "Delete", ev_update: "Update", ev_save: "Save Event",
    ev_sheets_label: "Sheets", ev_sheets_count: "sheet(s)",
    ev_product: "Product", ev_qty: "Qty", ev_unit_cost: "Unit Cost", ev_subtotal: "Subtotal",
    ev_gen_shopping: "Generate Shopping List", ev_cost: "Cost",
    ev_load_error: "Error loading data", ev_need_sheet: "Add at least one technical sheet to the event",
    ev_updated: "Event updated successfully!", ev_created: "Event created successfully!",
    ev_save_error: "Error saving event", ev_delete_confirm: "Are you sure you want to delete this event?",
    ev_deleted: "Event deleted successfully!", ev_delete_error: "Error deleting event",
    ev_produce_confirm: "Record production of event \"{name}\"?\nThis will deduct all ingredients from stock.",
    ev_produce_error: "Error recording event production", ev_insufficient: "Insufficient stock",
    ev_pdf_done: "Event PDF generated!", ev_whatsapp_opening: "Opening WhatsApp...",

    // Etapa 10: Team (remaining)
    tm_invite_link: "Invite by link", tm_invite_link_desc: "Generate a link and send it. The person creates their own password (or signs in with an existing account) and joins your team. Valid for 7 days.",
    tm_access_level: "Access level",
    tm_role_editor_desc: "Editor — can create and edit", tm_role_viewer_desc: "Viewer — read only", tm_role_admin_desc: "Administrator — full access",
    tm_generate_link: "Generate link", tm_generating: "Generating...", tm_link_label: "Invite link",
    tm_link_copied: "Link copied!", tm_copy_manual: "Select the link and copy it manually (Ctrl+C)",
    tm_link_note: "If the person already has an account, their data becomes personal items when joining.",
    tm_email_hint: "If this email already has a SOP & RAFT account, it will be linked to your team and their data becomes personal items.",
    tm_role_hint: "If a position is selected below, the position level prevails.",
    tm_position_example: "E.g.: Head Chef", tm_link_error: "Error generating link",

    // Etapa 10: Pagination
    pg_showing: "Showing", pg_page: "Page",
  },

  es: {
    app_name: "SOP & RAFT", app_subtitle: "Cocina Inteligente",
    app_full: "Sistema Operativo de Precios & Recetas Adaptadas en Fichas Técnicas",

    login: "Iniciar sesión", register: "Registrarse", email: "Correo", password: "Contraseña", name: "Nombre",
    create_account: "Crear Cuenta", your_access_data: "Tus datos de acceso",
    already_have_account: "¿Ya tienes cuenta?", login_link: "Inicia sesión",
    no_account: "¿No tienes cuenta?", register_link: "Regístrate",
    min_6_chars: "Mínimo 6 caracteres", next: "Siguiente", previous: "Anterior", back: "Volver",
    welcome_back: "Bienvenido de nuevo", enter_credentials: "Ingresa tus credenciales",
    your_password: "Tu contraseña", name_placeholder: "Tu nombre", email_placeholder: "tu@correo.com",

    business_profile: "Perfil del Negocio", how_identify: "¿Cómo te identificas?",
    autonomo: "Autónomo", autonomo_desc: "Productor casero, emprendedor individual. Interfaz simplificada.",
    empresa: "Empresa", empresa_desc: "Restaurante, buffet, panadería, franquicia. Todos los módulos disponibles.",
    business_name: "Nombre del Negocio", business_name_placeholder: "Ej: Dulces de Ana",
    optional: "opcional", advanced_modules: "Módulos Avanzados",
    all_preselected: "Todos los módulos están preseleccionados. Desmarca lo que no necesites.",
    select_extras: "Selecciona módulos extras. Puedes activarlos después en el Centro de Módulos.",
    creating: "Creando...",

    language: "Idioma", select_language: "Elige el idioma de la aplicación",

    section_operation: "Operacion", section_financial: "Financiero", section_stock: "Inventario y Logistica", section_planning: "Planificacion", section_admin: "Administracion",
    nav_dashboard: "Menú Principal", nav_ingredients: "Ingredientes", nav_stock: "Inventario",
    nav_tech_sheets: "Fichas Técnicas", nav_production_orders: "Órdenes de Producción",
    nav_measures: "Conversiones", nav_pricing: "Precios", nav_analytics: "Análisis",
    nav_dre: "P&G / CMV", nav_waste: "Desperdicio", nav_events: "Eventos",
    nav_shopping: "Lista de Compras", nav_suppliers: "Proveedores",
    nav_attack_plan: "Plan de Ataque", nav_menu_eng: "Ing. de Menú", nav_menu_builder: "Menús & Cartas",
    nav_team: "Equipo", nav_reports: "Reportes", nav_checklists: "Checklists", nav_pracas: "Estaciones", nav_memory: "Memoria IA", nav_module_center: "Centro de Módulos",

    save: "Guardar", cancel: "Cancelar", delete: "Eliminar", edit: "Editar", create: "Crear",
    add: "Agregar", search: "Buscar", confirm: "Confirmar", close: "Cerrar",
    export_pdf: "PDF", share_whatsapp: "WhatsApp", loading: "Cargando...",
    no_data: "No se encontraron datos.", success: "¡Éxito!", error: "Error",
    logout: "Salir", change_password: "Contraseña", help: "Ayuda", actions: "Acciones",
    quantity: "Cantidad", unit: "Unidad", cost: "Costo", price: "Precio",
    total: "Total", date: "Fecha", status: "Estado", notes: "Observaciones",
    category: "Categoría", description: "Descripción", view: "Ver", copy: "Copiar",
    produce: "Producir", generate: "Generar", apply: "Aplicar", update: "Actualizar",
    new_item: "Nuevo", all: "Todos", none: "Ninguno", yes: "Sí", no: "No",
    required: "Obligatorio", items: "ítems", of: "de",
    confirm_delete: "¿Estás seguro de que deseas eliminar?",

    dash_overview: "Visión general de tu negocio", dash_estimated_profit: "Ganancia Estimada",
    dash_total_cost: "Costo Total", dash_products: "Productos", dash_ingredients_count: "Ingredientes",
    dash_stock_alerts: "Alertas de Inventario", dash_all_good: "¡Todo en orden!",
    dash_no_shortage: "Ningún ingrediente faltante", dash_quick_access: "Acceso Rápido",
    dash_new_sheet: "Nueva Ficha Técnica", dash_register_purchase: "Registrar Compra",
    dash_shopping_list: "Lista de Compras", dash_events: "Eventos",
    dash_create_recipe: "Crear una nueva receta", dash_stock_entry: "Entrada de inventario",
    dash_gen_shopping: "Generar lista de compras", dash_manage_events: "Gestionar eventos",
    dash_low_stock: "con inventario bajo", dash_out_of_stock: "sin inventario",

    ing_title: "Ingredientes", ing_subtitle: "Gestiona tus insumos y materias primas",
    ing_new: "Nuevo Ingrediente", ing_edit: "Editar Ingrediente",
    ing_name: "Nombre del Ingrediente", ing_package_qty: "Cantidad del Paquete",
    ing_purchase_price: "Precio de Compra", ing_cost_per_unit: "Costo por Unidad",
    ing_eq_weight: "Peso Equivalente (g)", ing_no_ingredients: "Ningún ingrediente registrado.",
    ing_search: "Buscar ingrediente...", ing_fc: "FC Estándar",

    stock_title: "Inventario", stock_subtitle: "Control de entradas y salidas de ingredientes",
    stock_entry: "Entrada", stock_exit: "Salida", stock_scan: "Escanear Factura",
    stock_current: "Inventario Actual", stock_minimum: "Mínimo", stock_set_minimum: "Definir Inventario Mínimo",
    stock_history: "Historial de Movimientos", stock_no_movements: "Sin movimientos",
    stock_low_alert: "¡Inventario bajo!", stock_entry_note: "Nota de entrada", stock_exit_note: "Nota de salida",

    ts_title: "Fichas Técnicas", ts_subtitle: "Recetas completas con costos calculados",
    ts_new: "Nueva Ficha", ts_edit: "Editar Ficha", ts_yield: "Rendimiento",
    ts_total_cost: "Costo Total", ts_cost_per_unit: "Costo/Unidad",
    ts_ingredients: "Ingredientes", ts_add_ingredient: "Agregar Ingrediente",
    ts_add_sub_recipe: "Sub-receta", ts_prep_mode: "Modo de Preparación",
    ts_photo: "Foto", ts_baker_pct: "Porcentaje Panadero", ts_qb: "QB",
    ts_gross_weight: "Peso Bruto", ts_net_weight: "Peso Neto", ts_fc: "FC",
    ts_item_cost: "Costo Ítem", ts_search: "Buscar ficha técnica...",
    ts_no_sheets: "Ninguna ficha técnica registrada.",
    ts_portion_weight: "Gramaje/Porción (kg)", ts_select_ingredient: "Seleccionar ingrediente",
    ts_select_sheet: "Seleccionar ficha...",

    pr_title: "Precios", pr_subtitle: "Calcula el precio de venta de tus productos",
    pr_method: "Método", pr_markup: "Markup", pr_margin: "Margen de Ganancia",
    pr_selling_price: "Precio de Venta", pr_profit: "Ganancia", pr_per_unit: "por unidad",
    pr_overhead: "Costo Operativo", pr_understand: "Entender Cálculo",
    pr_no_pricing: "Ningún precio registrado.",

    an_title: "Análisis", an_subtitle: "Indicadores financieros de tus productos",
    an_most_profitable: "Más Rentables", an_risk: "Productos en Riesgo",
    an_cost_vs_price: "Costo vs Precio",

    ev_title: "Eventos", ev_subtitle: "Gestiona tus eventos y pedidos",
    ev_new: "Nuevo Evento", ev_edit: "Editar Evento",
    ev_name: "Nombre del Evento", ev_date: "Fecha del Evento",
    ev_sheets: "Fichas del Evento", ev_estimated_cost: "Costo Estimado",
    ev_shopping_list: "Generar Lista de Compras", ev_pricing: "Cotizar",
    ev_no_events: "Ningún evento registrado.",

    sl_title: "Lista de Compras", sl_subtitle: "Genera listas de compras y consulta el historial",
    sl_new_list: "Nueva Lista", sl_saved_lists: "Listas Guardadas",
    sl_tech_sheets: "Fichas Técnicas", sl_extra_ingredients: "Ingredientes Sueltos",
    sl_generate: "Generar Lista", sl_deduct_stock: "Descontar Inventario",
    sl_confirm_purchase: "Confirmar Compra", sl_purchase_confirmed: "Compra Confirmada",
    sl_save_list: "Guardar Lista", sl_list_name: "Nombre de la lista (opcional)",
    sl_no_saved: "Ninguna lista guardada.", sl_items_count: "Ingredientes",
    sl_packages: "Paquetes Total", sl_total_cost: "Costo Total",
    sl_pending: "Pendiente", sl_confirmed: "Confirmada", sl_stock_deducted: "Inventario descontado",
    sl_search_sheet: "Buscar ficha técnica...", sl_search_extra: "Buscar ingrediente suelto...",
    sl_generated: "Lista de Compras Generada", sl_package_size: "Tam. Paquete",
    sl_packages_needed: "Paquetes", sl_price_per_package: "Precio/Paquete",

    mc_title: "Conversión de Medidas", mc_subtitle: "Tabla de referencia para conversiones culinarias",
    mc_ingredient: "Ingrediente", mc_teaspoon: "Cucharadita", mc_tablespoon: "Cucharada", mc_cup: "Taza",

    ap_title: "Plan de Ataque", ap_subtitle: "Organiza la producción de la cocina",
    ap_generate_ai: "Generar con IA", ap_create_manual: "Crear Manualmente",
    ap_select_sheets: "Selecciona fichas para el plan",
    ap_phase: "Fase", ap_task: "Tarea", ap_done: "Completada",
    ap_no_plans: "Ningún plan de ataque creado.",

    dre_title: "P&G / CMV", dre_subtitle: "Estado de Resultados y Costo de Mercancía Vendida",
    dre_monthly: "P&G Mensual", dre_cmv_history: "Historial CMV", dre_sales: "Ventas",
    dre_register_sale: "Registrar Venta", dre_revenue: "Ingreso Bruto",
    dre_cmv: "CMV", dre_op_costs: "Costos Operativos", dre_gross_profit: "Ganancia Bruta",
    dre_net_profit: "Ganancia Neta", dre_net_margin: "Margen",
    dre_cmv_target: "Meta CMV: 28% a 35%", dre_within_target: "¡Dentro de la meta!",
    dre_above_target: "Encima de la meta — revisa costos o precios.",
    dre_select_product: "Selecciona el producto vendido...", dre_amount_received: "Monto Recibido",
    dre_no_sales: "Ninguna venta registrada aún.", dre_simplified: "P&G Simplificado",

    sup_title: "Proveedores", sup_subtitle: "Gestión de proveedores y contactos",
    sup_new: "Nuevo Proveedor", sup_edit: "Editar Proveedor",
    sup_contact: "Contacto", sup_phone: "Teléfono", sup_categories: "Categorías",
    sup_address: "Dirección", sup_no_suppliers: "Ningún proveedor registrado.", sup_search: "Buscar proveedor...",

    po_title: "Órdenes de Producción", po_subtitle: "Planifica y controla la producción",
    po_new: "Nueva Orden", po_name: "Nombre de la Orden", po_scheduled: "Fecha Programada",
    po_start: "Iniciar", po_complete: "Completar", po_cancel_order: "Cancelar",
    po_pending: "Pendiente", po_in_production: "En Producción", po_completed: "Completada",
    po_cancelled: "Cancelada", po_no_orders: "Ninguna orden de producción.",
    po_confirm_complete: "¿Completar esta orden? El inventario será descontado automáticamente.",

    ws_title: "Control de Desperdicio", ws_subtitle: "Registra y analiza pérdidas de la operación",
    ws_new: "Registrar Pérdida", ws_reason: "Motivo", ws_estimated_cost: "Costo Est.",
    ws_expired: "Vencido", ws_damage: "Rotura/Daño", ws_leftover: "Sobra de Producción",
    ws_prep_loss: "Pérdida en Preparación", ws_other: "Otro",
    ws_monthly_records: "Registros (Mes)", ws_total_loss: "Costo Total Pérdidas",
    ws_no_records: "Ningún registro de desperdicio.",

    tm_title: "Equipo y Permisos", tm_subtitle: "Gestiona miembros, cargos y módulos de acceso",
    tm_invite: "Invitar Miembro", tm_role: "Rol", tm_audit: "Auditoría",
    tm_admin: "Administrador", tm_editor: "Editor", tm_viewer: "Visualizador",
    tm_initial_password: "Contraseña inicial", tm_change_first_login: "El miembro debe cambiar la contraseña en el primer acceso.",
    tm_no_audit: "Ninguna actividad registrada.", tm_datetime: "Fecha/Hora",
    tm_user: "Usuario", tm_action: "Acción", tm_details: "Detalles",
    tm_employee: "Empleado", tm_owner: "Propietario",
    tm_employee_badge: "Empleado", tm_owner_badge: "Propietario",
    tm_readonly_notice: "Tienes acceso solo para visualización.",
    tm_team_tab: "Equipo", tm_remove_confirm: "¿Eliminar a {name} del equipo?",
    tm_name_required: "Nombre y correo son obligatorios",
    tm_invited_success: "¡Miembro invitado!",
    tm_role_updated: "¡Rol actualizado!", tm_member_removed: "Miembro eliminado",
    tm_viewer_write_blocked: "Permiso insuficiente — solo visualización",
    tm_positions_tab: "Cargos", tm_position: "Cargo", tm_no_position: "Sin cargo",
    tm_new_position: "Nuevo Cargo", tm_position_name: "Nombre del Cargo",
    tm_permission_level: "Nivel de Permiso",
    tm_position_created: "¡Cargo creado!", tm_position_updated: "¡Cargo actualizado!",
    tm_position_deleted: "¡Cargo eliminado!",
    tm_edit_member: "Editar Empleado", tm_modules: "Módulos",
    tm_select_modules: "Selecciona los módulos que este empleado puede acceder",
    tm_all_modules: "Todos los módulos de la empresa",
    tm_member_updated: "¡Empleado actualizado!",
    tm_no_positions: "Ningún cargo creado. Crea cargos para organizar tu equipo.",
    tm_delete_position_confirm: "¿Eliminar el cargo '{name}'?",
    tm_save: "Guardar",

    me_title: "Ingeniería de Menú", me_subtitle: "Análisis de popularidad × rentabilidad de tus productos",
    me_star: "Estrella", me_workhorse: "Caballo de Carga", me_puzzle: "Rompecabezas", me_dog: "Perro",
    me_star_desc: "Alta popularidad + Alta rentabilidad",
    me_workhorse_desc: "Alta popularidad + Baja rentabilidad",
    me_puzzle_desc: "Baja popularidad + Alta rentabilidad",
    me_dog_desc: "Baja popularidad + Baja rentabilidad",
    me_no_data: "Registra ventas para ver el análisis del menú.", me_sold: "vendido(s)", me_total_profit: "ganancia total",

    bi_title: "Reportes & BI", bi_subtitle: "Visión consolidada del negocio",
    bi_revenue: "Ingreso", bi_cmv: "CMV", bi_waste: "Desperdicio",
    bi_net_profit: "Ganancia Neta", bi_margin: "Margen",
    bi_alerts: "Alertas Inteligentes", bi_trend: "Tendencia Mensual (6 meses)",
    bi_low_stock: "ingrediente(s) con inventario bajo", bi_expiring: "lote(s) venciendo en 7 días",
    bi_price_up: "precio subió", bi_price_down: "precio bajó",
    bi_sales_month: "Ventas del Mes", bi_ops_completed: "OPs Completadas",
    bi_avg_ticket: "Ticket Promedio", bi_vs_prev: "vs mes anterior",
    bi_target: "Meta: 28-35%", bi_no_data: "Sin datos",

    mod_title: "Centro de Módulos", mod_subtitle: "Activa o desactiva funcionalidades de tu panel.",
    mod_profile: "Perfil", mod_core: "Core Operativo — Siempre Activo",
    mod_advanced: "Módulos Avanzados de Escala",
    mod_deactivate_info: "Desactivar un módulo oculta las pantallas pero preserva todos tus datos.",

    souschef_title: "Sous-Chef AI", souschef_subtitle: "Copiloto Gastronómico",
    souschef_greeting: "¡Hola! Soy Sous-Chef AI",
    souschef_desc: "Puedo crear recetas, ayudar con precios, explicar funcionalidades y mucho más.",
    souschef_placeholder: "Pregunta al Sous-Chef...",
    souschef_recipe_detected: "Receta Detectada", souschef_apply: "Aplicar a Ficha Técnica",

    search_placeholder: "Buscar ingredientes, fichas, proveedores...",
    search_no_results: "Ningún resultado encontrado",

    pwd_change: "Cambiar Contraseña", pwd_current: "Contraseña Actual", pwd_new: "Nueva Contraseña",
    pwd_confirm: "Confirmar Nueva Contraseña", pwd_current_placeholder: "Ingresa tu contraseña actual",
    pwd_new_placeholder: "Mínimo 6 caracteres", pwd_confirm_placeholder: "Repite la nueva contraseña",
    pwd_mismatch: "Las contraseñas no coinciden", pwd_too_short: "La nueva contraseña debe tener al menos 6 caracteres",
    pwd_changed: "¡Contraseña cambiada exitosamente!",
    // Fichas Técnicas — Etapa 5 i18n
    ts_manage_subtitle: "Crea y gestiona las recetas de tus productos",
    ts_export_excel: "Exportar Excel", ts_measures: "Medidas", ts_import_ai: "Importar con IA",
    ts_new_sheet: "Nueva Ficha Técnica", ts_edit_sheet: "Editar Ficha Técnica",
    ts_edit_ingredient: "Editar Ingrediente", ts_save_changes: "Guardar cambios", ts_cancel: "Cancelar",
    ts_search_sheet: "Buscar ficha...", ts_sort_edited: "Editadas recientemente", ts_sort_opened: "Abiertas recientemente",
    ts_sort_created: "Creadas recientemente", ts_sort_az: "Orden alfabético (A-Z)", ts_sort_za: "Orden alfabético (Z-A)",
    ts_all_types: "Todos los tipos", ts_normal_sheets: "Fichas normales", ts_subrecipes: "Sub-recetas",
    ts_registered: "Fichas Técnicas Registradas", ts_personal: "Fichas Técnicas Personales",
    ts_loading: "Cargando...", sl_confirm_purchase: "Confirmar Compra",

    // Etapa 10: Inventario
    st_title: "Inventario", st_subtitle: "Control de entradas, salidas y stock mínimo",
    st_scan_receipt: "Escanear Nota", st_entry: "Entrada", st_exit: "Salida",
    st_items: "Ítems en Stock", st_total_value: "Valor Total", st_low: "Stock Bajo", st_zero: "Agotados",
    st_alerts_title: "Alertas de Stock", st_min_short: "mín", st_current_tab: "Stock Actual", st_history_tab: "Historial",
    st_no_items: "Ningún ítem en stock", st_no_items_hint: "Registra ingredientes y entradas",
    st_ingredient: "Ingrediente", st_minimum: "Mínimo", st_value: "Valor",
    st_no_movements: "Sin movimientos", st_no_movements_hint: "El historial aparecerá aquí",
    st_type: "Tipo", st_note_opt: "Observación (opcional)",
    st_register_entry: "Registrar Entrada", st_register_exit: "Registrar Salida",
    st_select_placeholder: "Seleccione...", st_confirm_entry: "Confirmar Entrada", st_confirm_exit: "Confirmar Salida",
    st_define_min: "Definir Stock Mínimo", st_min_qty: "Cantidad mínima",
    st_min_hint: "Se mostrará una alerta cuando el stock caiga por debajo de este valor",
    st_entry_success: "¡Entrada registrada con éxito!", st_exit_success: "¡Salida registrada con éxito!",
    st_entry_error: "Error al registrar entrada", st_exit_error: "Error al registrar salida",
    st_select_required: "Selecciona un ingrediente e informa la cantidad",
    st_min_updated: "¡Stock mínimo actualizado!", st_min_error: "Error al actualizar stock mínimo",
    st_load_error: "Error al cargar inventario", st_ok: "OK", st_low_badge: "Bajo", st_zero_badge: "Agotado",
    st_set_min_title: "Definir mínimo", st_min_btn: "Mín",

    // Etapa 10: Eventos (restante)
    ev_edit_event: "Editar Evento", ev_new_event: "Nuevo Evento", ev_date_opt: "Fecha (opcional)", ev_desc_opt: "Descripción (opcional)",
    ev_name_label: "Nombre del Evento", ev_name_placeholder: "Ej: Boda 200 invitados", ev_desc_placeholder: "Detalles del evento...",
    ev_no_sheets: "Ninguna ficha técnica registrada.", ev_create_first: "¡Crea tu primer evento!",
    ev_search: "Buscar evento...", ev_view: "Ver", ev_shopping: "Compras", ev_produce: "Producir",
    ev_delete: "Eliminar", ev_update: "Actualizar", ev_save: "Guardar Evento",
    ev_sheets_label: "Fichas", ev_sheets_count: "ficha(s)",
    ev_product: "Producto", ev_qty: "Cant.", ev_unit_cost: "Costo Unit.", ev_subtotal: "Subtotal",
    ev_gen_shopping: "Generar Lista de Compras", ev_cost: "Costo",
    ev_load_error: "Error al cargar datos", ev_need_sheet: "Agrega al menos una ficha técnica al evento",
    ev_updated: "¡Evento actualizado con éxito!", ev_created: "¡Evento creado con éxito!",
    ev_save_error: "Error al guardar evento", ev_delete_confirm: "¿Seguro que deseas eliminar este evento?",
    ev_deleted: "¡Evento eliminado con éxito!", ev_delete_error: "Error al eliminar evento",
    ev_produce_confirm: "¿Registrar la producción del evento \"{name}\"?\nEsto descontará todos los ingredientes del stock.",
    ev_produce_error: "Error al registrar producción del evento", ev_insufficient: "Stock insuficiente",
    ev_pdf_done: "¡PDF del evento generado!", ev_whatsapp_opening: "Abriendo WhatsApp...",

    // Etapa 10: Equipo (restante)
    tm_invite_link: "Invitar por enlace", tm_invite_link_desc: "Genera un enlace y envíalo. La persona crea su propia contraseña (o entra con su cuenta existente) y se une a tu equipo. Válido por 7 días.",
    tm_access_level: "Nivel de acceso",
    tm_role_editor_desc: "Editor — puede crear y editar", tm_role_viewer_desc: "Visualizador — solo lectura", tm_role_admin_desc: "Administrador — acceso total",
    tm_generate_link: "Generar enlace", tm_generating: "Generando...", tm_link_label: "Enlace de invitación",
    tm_link_copied: "¡Enlace copiado!", tm_copy_manual: "Selecciona el enlace y cópialo manualmente (Ctrl+C)",
    tm_link_note: "Si la persona ya tiene cuenta, sus datos se vuelven ítems personales al unirse.",
    tm_email_hint: "Si este correo ya tiene cuenta en SOP & RAFT, se vinculará a tu equipo y sus datos se vuelven ítems personales.",
    tm_role_hint: "Si se selecciona un cargo abajo, el nivel del cargo prevalece.",
    tm_position_example: "Ej: Chef de Cocina", tm_link_error: "Error al generar enlace",

    // Etapa 10: Paginación
    pg_showing: "Mostrando", pg_page: "Página",
  },
};

export const LANGUAGES = [
  { code: "pt-BR", label: "Português (BR)", flag: "🇧🇷" },
  { code: "en", label: "English", flag: "🇺🇸" },
  { code: "es", label: "Español", flag: "🇪🇸" },
];

export function t(key, lang = "pt-BR") {
  return translations[lang]?.[key] || translations["pt-BR"]?.[key] || key;
}

export default translations;
